import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { neucollect02 } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const DECC01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-01/neucollect-02_DE-CC-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2021 - PDF - 258 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-01/neucollect-02_DE-CC-01_Basisinformationsblatt.pdf`,
        description: "Stand 08/2021 - PDF - 211 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-01/neucollect-02_DE-CC-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 211 KB",
    },
];

const DECC02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-02/neucollect-02_DE-CC-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2021 - PDF - 256 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-02/neucollect-02_DE-CC-02_Basisinformationsblatt.pdf`,
        description: "Stand 10/2021 - PDF - 203 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-02/neucollect-02_DE-CC-02_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 203 KB",
    },
];

const DECC03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-03",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-03/neucollect-02_DE-CC-03_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2021 - PDF - 257 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-03",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-03/neucollect-02_DE-CC-03_Basisinformationsblatt.pdf`,
        description: "Stand 11/2021 - PDF - 214 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-03",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-03/neucollect-02_DE-CC-03_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 214 KB",
    },
];

const DECC04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-04/neucollect-02_DE-CC-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2022 - PDF - 253 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-04/neucollect-02_DE-CC-04_Basisinformationsblatt.pdf`,
        description: "Stand 01/2022 - PDF - 213 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-04/neucollect-02_DE-CC-04_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 213 KB",
    },
];

const DECC05DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-05",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-05/neucollect-02_DE-CC-05_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2022 - PDF - 254 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-05",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-05/neucollect-02_DE-CC-05_Basisinformationsblatt.pdf`,
        description: "Stand 02/2022 - PDF - 211 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-05",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-05/neucollect-02_DE-CC-05_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 211 KB",
    },
];

const DECC06DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-06",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-06/neucollect-02_DE-CC-06_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 04/2022 - PDF - 253 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-06",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-06/neucollect-02_DE-CC-06_Basisinformationsblatt.pdf`,
        description: "Stand 04/2022 - PDF - 209 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-06",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-06/neucollect-02_DE-CC-06_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 209 KB",
    },
];

const DECC07DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-07",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-07/neucollect-02_DE-CC-07_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2022 - PDF - 252 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-07",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-07/neucollect-02_DE-CC-07_Basisinformationsblatt.pdf`,
        description: "Stand 07/2022 - PDF - 210 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-07",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-07/neucollect-02_DE-CC-07_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 210 KB",
    },
];

const DECC08DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-08",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-08/neucollect-02_DE-CC-08_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2022 - PDF - 255 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-08",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-08/neucollect-02_DE-CC-08_Basisinformationsblatt.pdf`,
        description: "Stand 08/2022 - PDF - 212 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-08",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-08/neucollect-02_DE-CC-08_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 212 KB",
    },
];
const DECC09DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-09",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-09/neucollect-02_DE-CC-09_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2022 - PDF - 255 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-09",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-09/neucollect-02_DE-CC-09_Basisinformationsblatt.pdf`,
        description: "Stand 09/2022 - PDF - 212 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-09",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-09/neucollect-02_DE-CC-09_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 212 KB",
    },
];

const DECC10DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-CC-10",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-10/neucollect-02_DE-CC-10_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2023 - PDF - 251 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-CC-10",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-10/neucollect-02_DE-CC-10_Basisinformationsblatt.pdf`,
        description: "Stand 02/2023 - PDF - 184 KB",
    },
    {
        title: "Verlängerung Angebotszeitraum MEE-SVB",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/DE-CC-10/neucollect-02_DE-CC-10_Verlaengerung_Angebotszeitraum_MEE-Token.pdf`,
        description: "Stand 07/2023 - PDF - 1200 KB",
    },
];

const WAPP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-PP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-01/neucollect-02_WA-PP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2022 - PDF - 253 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-01/neucollect-02_WA-PP-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2022 - PDF - 230 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-01/neucollect-02_WA-PP-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 230 KB",
    },
];

const WARX01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-RX-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-01/neucollect-02_WA-RX-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2022 - PDF - 255 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-RX-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-01/neucollect-02_WA-RX-01_Basisinformationsblatt.pdf`,
        description: "Stand 10/2022 - PDF - 209 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-RX-01",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-01/neucollect-02_WA-RX-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 209 KB",
    },
];

const WAPP02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-PP-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-02/neucollect-02_WA-PP-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2022 - PDF - 257 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-02/neucollect-02_WA-PP-02_Basisinformationsblatt.pdf`,
        description: "Stand 11/2022 - PDF - 208 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-02/neucollect-02_WA-PP-02_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 208 KB",
    },
];

const CDPPWAPP02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-WA-PP-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-PP-02/neucollect-02_CD-PP-WA-PP-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2022 - PDF - 258 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-WA-PP-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-PP-02/neucollect-02_CD-PP-WA-PP-02_Basisinformationsblatt.pdf`,
        description: "Stand 11/2022 - PDF - 208 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-WA-PP-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-PP-02/neucollect-02_CD-PP-WA-PP-02_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 208 KB",
    },
];

const WAPP03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-PP-03",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-03/neucollect-02_WA-PP-03_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 12/2022 - PDF - 255 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-03",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-03/neucollect-02_WA-PP-03_Basisinformationsblatt.pdf`,
        description: "Stand 12/2022 - PDF - 210 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-03",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-03/neucollect-02_WA-PP-03_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 210 KB",
    },
];

const WAPP04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-PP-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-04/neucollect-02_WA-PP-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2023 - PDF - 252 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-04/neucollect-02_WA-PP-04_Basisinformationsblatt.pdf`,
        description: "Stand 01/2023 - PDF - 184 KB",
    },
];

const WAPP05DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-PP-05",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-05/neucollect-02_WA-PP-05_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2023 - PDF - 253 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-05",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-05/neucollect-02_WA-PP-05_Basisinformationsblatt.pdf`,
        description: "Stand 01/2023 - PDF - 187 KB",
    },
];

const WARX02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-RX-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-02/neucollect-02_WA-RX-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2023 - PDF - 254 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-RX-02",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-02/neucollect-02_WA-RX-02_Basisinformationsblatt.pdf`,
        description: "Stand 03/2023 - PDF - 184 KB",
    },
];

const WAPP06DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-PP-06",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-06/neucollect-02_WA-PP-06_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2023 - PDF - 255 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-06",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-06/neucollect-02_WA-PP-06_Basisinformationsblatt.pdf`,
        description: "Stand 03/2023 - PDF - 187 KB",
    },
];

const CDPPWAPP06DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-WA-PP-06",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-PP-06/neucollect-02_CD-PP-WA-PP-06_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2023 - PDF - 256 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-WA-PP-06",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-PP-06/neucollect-02_CD-PP-WA-PP-06_Basisinformationsblatt.pdf`,
        description: "Stand 03/2023 - PDF - 183 KB",
    },
];

const WAPP07DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-PP-07",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-07/neucollect-02_WA-PP-07_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 05/2023 - PDF - 131 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-07",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-07/neucollect-02_WA-PP-07_Basisinformationsblatt.pdf`,
        description: "Stand 05/2023 - PDF - 188 KB",
    },
];

const WARX03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-RX-03",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-03/neucollect-02_WA-RX-03_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 06/2023 - PDF - 122 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-RX-03",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-03/neucollect-02_WA-RX-03_Basisinformationsblatt.pdf`,
        description: "Stand 06/2023 - PDF - 190 KB",
    },
];

const WAPP08DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-PP-08",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-08/neucollect-02_WA-PP-08_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2023 - PDF - 133 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-PP-08",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-PP-08/neucollect-02_WA-PP-08_Basisinformationsblatt.pdf`,
        description: "Stand 07/2023 - PDF - 190 KB",
    },
];

const CDPPWAPP08DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-WA-PP-08",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-PP-08/neucollect-02_CD-PP-WA-PP-08_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2023 - PDF - 133 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-WA-PP-08",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-PP-08/neucollect-02_CD-PP-WA-PP-08_Basisinformationsblatt.pdf`,
        description: "Stand 07/2023 - PDF - 191 KB",
    },
];

const WARX04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen WA-RX-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-04/neucollect-02_WA-RX-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2023 - PDF - 135 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* WA-RX-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/WA-RX-04/neucollect-02_WA-RX-04_Basisinformationsblatt.pdf`,
        description: "Stand 08/2023 - PDF - 190 KB",
    },
];

const CDPPWARX04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-WA-RX-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-RX-04/neucollect-02_CD-PP-WA-RX-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2023 - PDF - 136 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-WA-RX-04",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-RX-04/neucollect-02_CD-PP-WA-RX-04_Basisinformationsblatt.pdf`,
        description: "Stand 08/2023 - PDF - 192 KB",
    },
];

const CDPPWARX05DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-WA-RX-05",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-RX-05/neucollect-02_CD-PP-WA-RX-05_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2023 - PDF - 134 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-WA-RX-05",
        path: `${DOCUMENT_HOST}/docs/general/neucollect/CD-PP-WA-RX-05/neucollect-02_CD-PP-WA-RX-05_Basisinformationsblatt.pdf`,
        description: "Stand 08/2023 - PDF - 191 KB",
    },
];

const Neucollect02 = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(neucollect02.title)}</title>

                <meta name="description" content="neucollect - 02 GmbH & Co. KG" />
            </Head>
            <div className="broad-container issuer-public-page neucollect">
                <section className="banner-section" style={{ backgroundImage: "url(/images/neucollect02.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/logo-neucollect-02.png"} alt="" />
                        </div>
                        <p className="">
                            Der Unternehmensgegenstand der Gesellschaft besteht in dem Erwerb, dem Halten und Verwalten von
                            Sachwerten (die „Sachwerte“), insbesondere Oldtimern und Weinen und anderen Gegenständen, die als
                            Sammlerstücke gelten.
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>neucollect - 02 GmbH & Co. KG</h2>
                        <p>
                            Bei der Finanzierung verfolgt die neucollect - 02 GmbH & Co. KG eine langfristig ausgerichtete
                            Strategie.
                        </p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC05DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC06DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC07DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC08DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC09DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECC10DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WAPP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WARX01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WAPP02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPWAPP02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WAPP03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WAPP04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WAPP05DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WARX02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WAPP06DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPWAPP06DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WAPP07DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WARX03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WAPP08DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPWAPP08DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={WARX04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPWARX04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPWARX05DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:neucollect-02@finexity.com">neucollect-02@finexity.com</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Neucollect02;
